const WEBCHAT_COLOR = {
  HECTOROUND_STYLE: [
    { name: 'develop', brands: [2] }, // 클게_데브1
    { name: 'develop2', brands: [5458] }, // 오근혁브랜드 수정
    { name: 'staging', brands: [5638, 5545] }, // 클라우드게이트QA
    { name: 'production', brands: [7584, 7597, 7598, 5706] } // ROUND, 클게_QA
  ]
};

const NAME_CUSTOM = {
  COUNSELOR_NAME: [
    { name: 'develop', brands: [2] }, // 클게_데브1
    { name: 'develop2', brands: [5458] }, // 오근혁브랜드 수정
    { name: 'staging', brands: [5638, 5545] }, // 클게_QA, 클라우드게이트QA
    { name: 'production', brands: [5168, 5706] } // 한국최저가철근, 클게_QA
  ]
};

const NOFILE_CUSTOM = {
  DUNAMU_CUSTOM: [
    { name: 'develop', brands: [2] }, // 클게_데브1
    { name: 'develop2', brands: [5458] }, // 오근혁브랜드 수정
    { name: 'staging', brands: [5638, 5545] }, // 클게_QA, 클라우드게이트QA
    { name: 'production', brands: [7699, 7738, 5706] } // 증권플러스비상장, 증권플러스비상장dev, 클게_QA
  ]
};
const getHectoRoundList = () => {
  return WEBCHAT_COLOR.HECTOROUND_STYLE.find((data) => data.name === process.env.VUE_APP_NODE_ENV);
};

const getNameCustomList = () => {
  return NAME_CUSTOM.COUNSELOR_NAME.find((data) => data.name === process.env.VUE_APP_NODE_ENV);
};

const getNoFileCustomList = () => {
  return NOFILE_CUSTOM.DUNAMU_CUSTOM.find((data) => data.name === process.env.VUE_APP_NODE_ENV);
};

export { getHectoRoundList, getNameCustomList, getNoFileCustomList };
